import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import OptionsOIChangeSinceLastExpiryFull from './options-oi-change-since-last-expiry-full';

const OptionsOIChangeSinceLastExpiryFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <OptionsOIChangeSinceLastExpiryFull {...props} />
    </QueryClientProvider>
  );
};

export { OptionsOIChangeSinceLastExpiryFullWidget }
